// extracted by mini-css-extract-plugin
module.exports = {"faq-header":"_3ZU2f","sub":"_3W8uu","sections":"_1p4j3","container":"_3LXXj"};